export enum TravelStatus {
  Empty = '',
  None = 'None',
  Pending = 'Pending',
  PreApproved = 'PreApproved',
  Approved = 'Approved',
  Confirmed = 'Confirmed',
  ErrorAtSending = 'ErrorAtSending',
  Paid = 'Paid',
  Reproved = 'Reproved',
  PaymentFailure = 'PaymentFailure',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
  ExchangePending = 'ExchangePending',
}

export type TravelTimelineStatus =
  | ''
  | 'None'
  | 'Pending'
  | 'PreApproved'
  | 'Approved'
  | 'Confirmed'
  | 'ErrorAtSending'
  | 'Paid'
  | 'Reproved'
  | 'PaymentFailure'
  | 'Expired'
  | 'Cancelled';
